import React, { useMemo, useEffect } from 'react';
import AllFolder from './AllFolder';
import { Dropdown, Menu, Affix } from 'antd';
import styles from './allFolder.module.scss';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
import { getIn18Text, apiHolder as api, apis } from 'api';
import { TongyongGengduo, TongyongQueren } from '@sirius/icons';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { FLOLDER, MAIL_ALL_FOLDER_SORT_KEY } from '@web-mail/common/constant';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const AllFolderContainer = props => {
    const [data] = useState2RM('AllFolderData');
    const { treeScroll } = props;
    const [storeFolderSortInfo, setStoreFolderSortInfo] = useUserLocalStorageState(MAIL_ALL_FOLDER_SORT_KEY, []);
    useEffect(() => {
        if (!storeFolderSortInfo || storeFolderSortInfo.length == 0 || storeFolderSortInfo.length < data.length) {
            if (data && data.length) {
                const defaultHideFolder = [FLOLDER.ALL_REDFLAG, FLOLDER.ALL_DRAFT];
                setStoreFolderSortInfo(data.map(item => ({ id: item.entry.mailBoxId, show: !defaultHideFolder.includes(+item.entry.mailBoxId) })));
            }
        }
    }, [data, storeFolderSortInfo]);
    const handleFodlerVisiableChange = useCreateCallbackForEvent((data) => {
        try {
            if (storeFolderSortInfo) {
                const list = [...storeFolderSortInfo];
                list.forEach(info => {
                    if (info.id === data.entry.mailBoxId) {
                        info.show = !info.show;
                        trackApi.track('pcMail_merge_folderTree_visiableChange', { folderId: data.entry.mailBoxId, show: !info.show });
                    }
                });
                setStoreFolderSortInfo(list);
            }
        }
        catch (error) {
            console.error('[error setStoreFolderSortInfo ]', error);
        }
    });
    const logicMenu = useMemo(() => {
        const shwoMap = {};
        storeFolderSortInfo === null || storeFolderSortInfo === void 0 ? void 0 : storeFolderSortInfo.forEach(item => {
            shwoMap[item.id] = item.show;
        });
        return (React.createElement(Menu, { className: styles.menu }, data
            .filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) != FLOLDER.ALL_RECEIVE; })
            .map(item => {
            var _a, _b;
            return (React.createElement(Menu.Item, { key: (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId, onClick: () => handleFodlerVisiableChange(item) },
                React.createElement("div", { className: styles.menuItemWrap },
                    React.createElement("div", { className: styles.menuItem }, item === null || item === void 0 ? void 0 : item.entry.mailBoxName),
                    shwoMap[(_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId] ? (React.createElement("div", { className: styles.flag },
                        React.createElement(TongyongQueren, null))) : (React.createElement(React.Fragment, null)))));
        })));
    }, [data, storeFolderSortInfo]);
    return (React.createElement("div", { className: styles.allFolderContainer + '   m-tree-container' },
        React.createElement(Affix, { target: () => treeScroll === null || treeScroll === void 0 ? void 0 : treeScroll.current, offsetTop: 0 },
            React.createElement("div", { className: styles.titleWrap },
                React.createElement("div", { className: styles.title }, getIn18Text('QUANBUYOUXIANG')),
                React.createElement("div", { className: styles.operWrap },
                    React.createElement(Dropdown, { placement: "bottomRight", overlay: logicMenu, trigger: ['click'] },
                        React.createElement("div", { className: styles.btnMore },
                            React.createElement("div", { className: styles.moroContent },
                                React.createElement(TongyongGengduo, { width: 16, height: 24 }))))))),
        React.createElement("div", { className: styles.treeWrap },
            React.createElement(AllFolder, { storeFolderSortInfo: storeFolderSortInfo, setStoreFolderSortInfo: setStoreFolderSortInfo, data: data, handleFodlerVisiableChange: handleFodlerVisiableChange }))));
};
export default AllFolderContainer;
